import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import DriverAWBTableMobile from '../../common/driver/DriverAWBTableMobile';
import DriverDOPOHeaderMobile from '../../common/driver/DriverDOPOHeaderMobile';
import DriverTruckerInfoMobile from '../../common/driver/DriverTruckerInfoMobile';
import DriverPickupFromDeliverTo from '../../common/driver/DriverPickupFromDeliverTo';
import DriverPODateTimeMobile from '../../common/driver/DriverPODateTimeMobile';

import PickupOrder from '../../../models/PickupOrder';

import style from '../../common/driver/ordersDriver.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '96%',
      height: '48px',
      margin: '25px 0 0 2%',
      textTransform: 'none'
    },
  });

interface PickupOrderProps {
  classes: any;
  pickupOrder: PickupOrder;
  doCheckIn: () => void;
  selectETA: () => void;
  printPickupOrder: () => void;
};

const pickupOrderDriver = (props: PickupOrderProps) => {

  const { classes, pickupOrder } = props;

  return (

    <div className={ style.container }>

      <DriverDOPOHeaderMobile order={ pickupOrder } type='po'/>

      <DriverPODateTimeMobile order={ pickupOrder } />

      <DriverPickupFromDeliverTo order={ pickupOrder } />

      <DriverAWBTableMobile orderListItems={ pickupOrder.list } />

      <DriverTruckerInfoMobile order={ pickupOrder } />

      <div className={ style.wrapperTrcInfo }>
        <span className={ style.pot }>Additional Trucker Information:</span>
        <span className={ style.pod }>{ pickupOrder.trucker_info }</span>
      </div>

      <Button
        variant="contained"
        className={ classes.button }
        color={ 'primary' }
        onClick={ props.selectETA }
        disabled={ !pickupOrder.allowed_ops.update_date }
      >
        Review dock situation and select slot
      </Button>

      <Button
        variant="contained"
        className={ classes.button }
        color={ 'primary' }
        onClick={ props.doCheckIn }
        disabled={ !!props.pickupOrder.driver_checkin_time || !pickupOrder.allowed_ops.driver_checked_in }
      >
        I am on location, Check me In
      </Button>

      <Button
        variant="contained"
        className={ classes.button }
        color={ 'primary' }
        onClick={ props.printPickupOrder }
      >
        Print pick Up Order
      </Button>
      
    </div>
  );
}

export default withStyles(styles)(pickupOrderDriver);